itsoftApp.createModule("scroll", function(){
    var where = "footer";
    var $document = itsoftApp.commonVars.$document;
    var duration = 500;

    var scroll = function(top) {
        if (isNaN(top)) {
            return;
        }
        $document.animate({
            "scrollTop": top
        }, {
            "duration": duration
        });
    };

    $(".js-map-heder").on("click", function(){

        scroll($(where).offset().top);
    });

    $(".js-top").on("click", function(){
        scroll(0);
    });
});